export default __webpack_public_path__ + "static/media/weight_card_2@2x.197b86d4.png";